import { render, staticRenderFns } from "./home_goods_list.vue?vue&type=template&id=644f99aa&scoped=true"
import script from "./home_goods_list.vue?vue&type=script&lang=js"
export * from "./home_goods_list.vue?vue&type=script&lang=js"
import style0 from "./home_goods_list.vue?vue&type=style&index=0&id=644f99aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f99aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644f99aa')) {
      api.createRecord('644f99aa', component.options)
    } else {
      api.reload('644f99aa', component.options)
    }
    module.hot.accept("./home_goods_list.vue?vue&type=template&id=644f99aa&scoped=true", function () {
      api.rerender('644f99aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_goods_list.vue"
export default component.exports